import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BackButton, Header, StyledBackButtonIcon, StyledSpace } from "./style";
import { StyledBreadcrumb } from "../../components/common/styles";

export const DietHeader = ({
  recipeName,
}: {
  recipeName: string | undefined;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const mapSegmentToName = (
    segment: string,
    index: number,
    pathParts: string[]
  ) => {
    switch (segment) {
      case "diet":
        return t("Diet");
      case "add":
        return t("Create");
      case "recipe-instructions":
        return t("Recipe Instructions");
      default:
        if (index > 0) {
          const prevSegment = pathParts[index - 1];
          if (prevSegment === "diet") {
            return recipeName || "-";
          }
        }
        return segment;
    }
  };

  const generateBreadcrumbs = () => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    const breadcrumbs = pathParts.map((part, index) => {
      const path = `/${pathParts.slice(0, index + 1).join("/")}`;
      return { label: mapSegmentToName(part, index, pathParts), path };
    });
    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const handleBackClick = () => {
    if (breadcrumbs.length > 1) {
      navigate(breadcrumbs[breadcrumbs.length - 2].path);
    } else {
      navigate(-1);
    }
  };

  return (
    <Header>
      <StyledSpace>
        <BackButton
          type="text"
          icon={<StyledBackButtonIcon />}
          onClick={handleBackClick}
        />
        <StyledBreadcrumb>
          {breadcrumbs.map((breadcrumb, index) => (
            <StyledBreadcrumb.Item
              key={index}
              onClick={() => navigate(breadcrumb.path)}
            >
              {breadcrumb.label}
            </StyledBreadcrumb.Item>
          ))}
        </StyledBreadcrumb>
      </StyledSpace>
    </Header>
  );
};
